
import { CustomButton } from "../components"
import { MainLayout } from "../components/layouts"
import styled from "styled-components"
import { COLORS } from "../constants"
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { ToastContainer, toast } from 'react-toastify';
import bag from "../assets/images/bag.svg"
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from "react-modal"
import axios from "axios"

import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';

import { Link } from "react-router-dom"


const StyledBasket = styled.div`
    background: white;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    border-radius: 10px;
    cursor: pointer;
    transition: box-shadow 0.2s;

    &:hover{
        box-shadow: none;
    }
`;

const StyledStoreItem = styled.div`
    text-align: center;
    display: flex;
    background: white;
    border-radius: 10px;
    height: 200px;
    opacity: ${props => props.loading ? 0.5 : 1};
`;
const StyledWrapper = styled.div`
    padding: 10px;
`;
const StyledColourSide = styled.div`
    
    height: 100%;
    width: 25%;
    display: flex;
    align-items: center;
    border-radius: 10px 0 40px 10px;
    justify-content: center;
`;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 10,
        border: 0
    },
    overlay: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};
const colors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]
function AppStore() {
    const user = useSelector(state => state.auth.user.user)
    const user_role = useSelector(state => state.auth.user.user_role)
    const [loading, setLoading] = useState(false)
    const api = process.env.REACT_APP_API_URL;
    const [basket, setBasket] = useState();
    const [items, setItems] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [serverError, setServerError] = useState('');

    useEffect(async () => {
        const response = await axios.get(`${api}/products_set/index/${user_role}`);
        const data = response.data;
        setItems(data.products)

    }, [])
    useEffect(async () => {
        updateBasketContents();

    }, [])
    const updateItem = (i) => {
        const newItems = [...items];
        newItems[i].open = !newItems[i].open;

        setItems(newItems);
    }
    const updateSku = (i, id, sku, name, price) => {

        const newItems = [...items];
        newItems[i].product_id = id;
        newItems[i].selected_sku = sku;
        if (name == 4) {
            newItems[i].selected_product_name = 'Full Level';
        } else {
            newItems[i].selected_product_name = 'Pack ' + name;
        }

        newItems[i].selected_product_price = price;

        setItems(newItems);
    }
    const apiBasketUpdate = (id, sku) => {
        setLoading(true)
        axios.post(`${api}/ps/add_to_basket`, { email_id: user.email, product_id: id, sku: sku }, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {

            if (res.data.status_code == -111 || res.data.status_code == -112 ||
                res.data.status_code == -113 || res.data.status_code == -114) {
                setServerError(res.data.message)
                setModalOpen(true)
            }
            else {
                toast("Product Added Successfully")
                updateBasketContents();
            }
            setLoading(false)
        }).catch(error => {
            console.log(error)
        });
    }
    const createBasket = () => {
        axios.post(`${api}/ps/create_basket`, { email_id: user.email }, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            console.log(res.data)

        }).catch(error => {
            alert("System cannot create new basket for you")
        });
    }
    const updateBasketContents = async () => {
        const response = await axios.get(`${api}/ps/basket_contents/${user.email}`)
        const data = response.data;
        console.log(data)
        setBasket(data.basket)

    }
    const addToBasket = (id, sku) => {

        axios.get(`${api}/ps/basket_contents/${user.email}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            if (res.data.status_code == 1) {
                apiBasketUpdate(id, sku);
            } else {
                createBasket();
                setTimeout(() => {
                    apiBasketUpdate(id, sku);
                }, 500);


            }

        }).catch(error => {
            console.log(error)
        });
    }
    return (
        <>
            <ReactModal ariaHideApp={false} isOpen={modalOpen} contentLabel="Error" role="dialog" style={customStyles} onRequestClose={() => setModalOpen(false)}>
                <div className="d-flex flex-column align-items-center">
                    <h5>Error</h5>
                    {serverError}
                    <CustomButton
                        style={{ width: 200, marginTop: 10 }}
                        color={COLORS.text_dark_green}
                        bgColor={COLORS.green}
                        hover={COLORS.text_green}
                        onClick={() => setModalOpen(false)}
                    >
                        Close
                </CustomButton>
                </div>
            </ReactModal>
            <MainLayout>
                <div className="d-flex justify-content-end">

                    {user_role != 3 && <div className="mt-4">
                        <div style={{ color: "black", textAlign: "center", marginBottom: 5 }}><span className="color-text-grey">Total:</span> £{basket && basket.total_price || '0.00'}</div>
                        <Link to="/store/basket">

                            <StyledBasket className="shadow-md">


                                <span style={{ color: "black" }}><img src={bag} width="20" style={{ marginBottom: 5, marginRight: 5 }} />Pay Now</span>
                            </StyledBasket>
                        </Link></div>
                    }
                </div>
                {user_role == 3 && <div style={{ height: 20 }}></div>}
                <div className="h3 color-text-blue mt-1 mb-0" style={{ color: "#1378AB" }}>Tell & Spell Store</div>
                <div className="h5 mt-4" style={{ color: "#9CB915" }}>Buy More Games</div>
                <div className="d-flex flex-wrap mt-3" style={{ margin: "-10px" }}>
                    {items.map((item, i) => {
                        return <StyledWrapper className="store-card" key={i}>
                            <StyledStoreItem key={i} loading={loading}>
                                <StyledColourSide style={{ background: colors[i].bgColor }}>
                                    <h3 style={{ color: colors[i].color }}>{item.level_no}</h3>
                                </StyledColourSide>
                                <div className="flex-grow-1 mt-4 pl-3 pr-3">
                                    <h5 className="text-center">LEVEL {item.level_no} GAMES</h5>
                                    <div style={{ color: "#808080" }}>50 Games Available</div>
                                    <Dropdown isOpen={item.open} toggle={() => updateItem(i)}>
                                        <DropdownToggle caret className="w-100 mt-2">
                                            {item.selected_product_name}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {user_role == 3 ? <DropdownItem header>Go to Family Account to buy more games</DropdownItem> : <DropdownItem header>Packs</DropdownItem>}

                                            {item.data[0].map((product, j) => {
                                                if (product.pack_no == 4)
                                                    return <DropdownItem key={j} onClick={() => updateSku(i, product.id, product.sku, product.pack_no, product.price)}>Full Level - 50 Games</DropdownItem>
                                                else if (product.pack_no == 3)
                                                    return <DropdownItem key={j} onClick={() => updateSku(i, product.id, product.sku, product.pack_no, product.price)}>Pack {product.pack_no} - 15 Games</DropdownItem>
                                                else if (product.pack_no == 2)
                                                    return <DropdownItem key={j} onClick={() => updateSku(i, product.id, product.sku, product.pack_no, product.price)}>Pack {product.pack_no} - 15 Games</DropdownItem>
                                                else if (product.pack_no == 1)
                                                    return <DropdownItem key={j} onClick={() => updateSku(i, product.id, product.sku, product.pack_no, product.price)}>Pack {product.pack_no} - 20 Games</DropdownItem>
                                            })}
                                        </DropdownMenu>
                                    </Dropdown>
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <span>£{item.selected_product_price}</span>

                                        <CustomButton
                                            onClick={() => addToBasket(item.product_id, item.selected_sku)}
                                            bgColor={COLORS.orange}
                                            color={COLORS.dark_orange}
                                            hover={COLORS.orange_hover}
                                            disabled={!item.selected_sku}
                                            style={{ padding: "0 10px", fontSize: 15, height: 38, borderRadius: 5 }}
                                        >
                                            Add To Cart
                                </CustomButton>

                                    </div>
                                </div>
                            </StyledStoreItem>
                        </StyledWrapper>
                    })}
                    <ToastContainer position="bottom-center" pauseOnHover={false} autoClose={2000} />
                </div>

            </MainLayout>
        </>
    );
}

export default AppStore;